import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[sch-scroll-end-notifier]',
  standalone: true,
})
export class SharedScrollEndNotifierDirective implements OnInit, OnDestroy {
  @Input() offset = 0;
  @Input() scrollDisabled = false;
  @Output() scrollEnd = new EventEmitter<void>();

  private wasAtEnd = false;
  private resizeObs?: ResizeObserver;
  private readonly isBrowser: boolean;

  constructor(
    private elRef: ElementRef<HTMLElement>,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    if (!this.isBrowser) return;

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObs = new ResizeObserver(() => {
        this.wasAtEnd = false;
      });

      this.resizeObs.observe(this.elRef.nativeElement);

      const firstChild = this.elRef.nativeElement
        .firstElementChild as Element | null;
      if (firstChild) this.resizeObs.observe(firstChild);
    }
  }

  ngOnDestroy() {
    if (!this.isBrowser) return;
    this.resizeObs?.disconnect();
  }

  @HostListener('scroll')
  onScroll() {
    if (!this.isBrowser) return;
    if (this.scrollDisabled) return;

    const el = this.elRef.nativeElement;
    const { scrollTop, clientHeight, scrollHeight } = el;

    const atEnd = scrollTop + clientHeight >= scrollHeight - this.offset;

    if (atEnd && !this.wasAtEnd) {
      this.wasAtEnd = true;
      this.scrollEnd.emit();
    }

    if (!atEnd && this.wasAtEnd) {
      this.wasAtEnd = false;
    }
  }

  public resetGuard() {
    this.wasAtEnd = false;
  }
}
